import ApiService from '@/core/services/api.service';

export default {
  /**
   * Lấy danh sách suppliers có phân trang
   */
  async getSuppliers(params = {}) {
    const response = await ApiService.query('v1/customers', { params });
    return response.data.data;
  },

  /**
   * Lấy thông tin customer theo id
   */
  async getById(id, params = {}) {
    const response = await ApiService.query(`v1/customers/${id}`, { params });
    return response.data.data;
  },

  /**
   * Tạo mới customer
   */
  async create(payload = {}) {
    const response = await ApiService.post('v1/customers', payload);
    return response.data;
  },
};
